import DiscoveryProvincesDetails from './DiscoveryProvincesDetails.container';

export default DiscoveryProvincesDetails;
